import { apiSlice } from './apiSlice'

import type { PnLRow } from '../../pages/dashboard/pnl/PnLTable'

/**
 * Cashflows Forecast dashboard data — `GET /api/v1/dashboard/cashflows`.
 *
 * Mirrors FastAPI `CashflowsDashboardResponse` (camelCase aliases). BE returns
 * DATA ROWS only; column/format config lives in `pages/dashboard/cashflows`.
 * Source: Report DB (`DATABASE_URL_REPORT`), ported 1:1 from the PBI page
 * "Cashflows Forecast". No params — the PBI page filter is a fixed relative
 * window (today .. today+49) computed server-side.
 */
export interface CashflowsDashboardResponse {
  /** Week-of-year of today (e.g. "2026-24") — header card. */
  currentWoy?: string | null
  /** Page window bounds, ISO `YYYY-MM-DD` (today .. today+49). */
  windowFrom?: string | null
  windowTo?: string | null
  /** Latest FX upload date inside the window (null = none yet today). */
  fxDate?: string | null
  fxRates: PnLRow[]
  /** Latest LRC price snapshot date (last 4 days). */
  marketDate?: string | null
  marketPrices: PnLRow[]
  cashAtBanks: PnLRow[]
  creditFacilities: PnLRow[]
  usdExposure: PnLRow[]
  /** Ordered woy column labels of the forecast matrix. */
  weeks: string[]
  /** Forecast rows: label/unit/bold/italic/red + w0..wN keyed by `weeks` index. */
  forecast: PnLRow[]
}

const dashboardCashflowsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCashflowsDashboard: builder.query<CashflowsDashboardResponse, void>({
      query: () => ({ url: '/dashboard/cashflows' }),
    }),
  }),
})

export const { useGetCashflowsDashboardQuery } = dashboardCashflowsApi
